import React, { useEffect, useRef, useState } from 'react'
import CtaHOC from './CtaHOC'
import { handleStatusGaCalls, handleUpdatedPlan, pushStepToFlow } from '../helper'
import { publishIsActive, subscribeIsActive } from '../Events/plans.events'
import { publishMorePurchaseList, publishRemoveOfferCode, subscribeDiscountData } from '../Events/monetisation.events'
import { publishTveStatus } from '../Events/tve.events'
import trackEvent, {getUserProperties} from '../../helpers/trackAnalytics'
import { ANALYTICSEVENTS } from '../LoginV2/Helpers/analyticsMap'
import pubsub from '@viewlift/pubsub'
import { publishScrollIntoView } from '../Events/utils.events'
import { fetchCurrentPlan } from './helper'
import { fetchUserObject } from '../MonetisationModule02/Stripe/helper'
import { getDeviceId , getCurrencySymbol, getLocalizedMonthYearText} from '../../helpers'
import { fetchAuthenticationStoreData } from '../../Hardwall/helper'
import { getUserLocation } from '../Viewplans02/api'

const MonetisationCta = ({ plan, ctaStyles, ctaStyleType, plans, parentModuleData, isActive, contentDetails }) => {
  let { cta, ctaHover } = ctaStyles
  let { title, subTitle, currency, amount, planId, type, subscriptionPopupFonts, plansDetail } = plan
  const showPlanFromPlanInfo = window?.app_data?.appcmsMain?.monetizationConfig?.showPlanFromPlanInfo || false;
  const ctaRef = useRef(null)
  const [active, setActive] = useState(false)
  const [discountedPrice, setDiscountedPrice] = useState(null) 

  const handleActivePlan = ({ planDetails, selectedPlanId, selectedType }) => {
      setDiscountedPrice(null)
      publishRemoveOfferCode(true)
    // if (planDetails?.type === "TVE") setActive(true)
    if (selectedPlanId === planId && selectedType === type) setActive(true)
    else setActive(false)
    if (planDetails?.type === "default") {
      setActive(false)
    }
  }

  const handleSelectedActivePlan = () => {
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    const authToken = urlParams.get("auth");
    const userEmail = urlParams.get("email");
    const userTveCode = urlParams.get("tveCode");
    const userPhoneNumber = urlParams.get("phoneNumber");
    const currentPath = location.pathname

    if((authToken && (userEmail || userPhoneNumber) && userTveCode && currentPath == '/checkout') ){
      let planDetails = {
        id: "TVE",
        type: "TVE",
        featureDetails: null
      }
      publishIsActive({selectedPlanId: 'TVE', planDetails, selectedType: plan?.type })
      publishTveStatus(true)
    }else {
      if (isActive) {
        if (plan?.planId === "TVE") {
          publishTveStatus(true)
          setActive(true)
          return
        }
        let planDetails = {
          id: plan?.planId,
          featureDetails: plan?.featureDetails
        }
        publishIsActive({ planDetails, selectedPlanId: plan?.planId, selectedType: plan?.type })
        setActive(true)
      }
    }
  }

  let fontpopupCtaTitleSize = subscriptionPopupFonts?.planBannerHeadingStyles?.fontSize || subscriptionPopupFonts?.popupCtaTitleFont?.fontSize
  let fontpopupCtaTitleStyle = subscriptionPopupFonts?.planBannerHeadingStyles?.fontFamily || subscriptionPopupFonts?.popupCtaTitleFont?.fontFamily
  let fontpopupCtaSubTitleSize = subscriptionPopupFonts?.planBannerSubHeadingStyles?.fontSize || subscriptionPopupFonts?.popupCtaSubTitleFont?.fontSize
  let fontpopupCtaSubTitleStyle = subscriptionPopupFonts?.planBannerSubHeadingStyles?.fontFamily || subscriptionPopupFonts?.popupCtaSubTitleFont?.fontFamily
  let fontpopupPriceFontSize = subscriptionPopupFonts?.planBannerSubHeadingStyles?.fontSize || subscriptionPopupFonts?.popupPriceFont?.fontSize
  let fontpopupPriceFontStyle = subscriptionPopupFonts?.planBannerSubHeadingStyles?.fontFamily || subscriptionPopupFonts?.popupPriceFont?.fontFamily


  const handleDiscountedData = (data) => {
    let { appliedOfferCode,
      amount,
      planId } = data
      if (planId === plan?.planId) {
        setDiscountedPrice(amount)
      }
      if (!appliedOfferCode) {
        setDiscountedPrice(null)
      }
  }

  useEffect(() => {
    handleSelectedActivePlan()
    subscribeIsActive(handleActivePlan)
    subscribeDiscountData(handleDiscountedData)
  }, [])

  const handleMorePurchaseOptions = () => {
    let subscriptionModal = {
      isOpen: true,
      plansData: plans,
      isCheckout: true,
      contentDetails
    }
    publishMorePurchaseList(subscriptionModal)
  }
  const displayStrikeThroughPrice = plan?.plansDetail?.displayStrikeThroughPrice || null
  const strikeThroughPrice = plan?.plansDetail?.strikeThroughPrice || null
  return (
    <div className={active ? 'monetisation-cta-container active-cta' : 'monetisation-cta-container'} ref={ctaRef} style={active ? {
      color: ctaHover?.color,
      backgroundColor : ctaHover?.backgroundColor} : cta}
      onMouseOver={() => {
      ctaRef.current.style.backgroundColor = ctaHover?.backgroundColor
      ctaRef.current.style.color = ctaHover?.color
      ctaRef.current.style.border = ctaHover?.border
    }}
      onMouseOut={() => {
        ctaRef.current.style.backgroundColor = active ? ctaHover?.backgroundColor : cta?.backgroundColor
        ctaRef.current.style.color = `${active ? ctaHover?.color : cta?.color}`
        ctaRef.current.style.border = cta?.border || "unset"
      }}
      onClick={async (e) => {
        if (plan.type === "NoPlans") {
          const authenticationStore = await fetchAuthenticationStoreData();
          const { user } = authenticationStore;
          const locationCoordsData = sessionStorage.getItem("locationCoords");

          const isLoggedIn = !!user;
          const hasLocation = !!locationCoordsData;
          const needsHbaFlow = isLoggedIn && !user?.hbaMetadata;

          if (!isLoggedIn && !hasLocation) {
            let location = await getUserLocation();
            if(location){
              pubsub.publish("reRender",true)
            }
          }

          if (needsHbaFlow) {
            pubsub.publish("showHbaFlow", true);
          }
          return;
        }
        e.stopPropagation()
        let planDetails = {
          id: planId ? planId : null,
          type,
          featureDetails: plan?.featureDetails
        }
        publishScrollIntoView(true)
        if (type === "more") {
         handleMorePurchaseOptions()
          return
        }
        let oldPlan = fetchCurrentPlan()
        let planSelectionEventData = {
          "planId": oldPlan?.planId,
          "planName": oldPlan?.title,
          "planType": oldPlan?.cycleType,
          "planDesc": oldPlan?.description,
          "pageUrl": window?.location.href
      }
        if (oldPlan) {
          let analyticsData={ename:ANALYTICSEVENTS.PLAN_UPDATE, data: planSelectionEventData};
            pubsub.publish('user-analytics',analyticsData)
            handleStatusGaCalls({eventName : 'plan_update',subSection : null, type : 'plan', reason : oldPlan?.title, status : plan?.title, additionalLabel : null, action : 'Update Plan', paymentStatus : null,eventCategory : 'Subscription',section : 'checkout'})
        }else {
            let analyticsData={ename:ANALYTICSEVENTS.PLAN_SELECTION, data: planSelectionEventData};
            pubsub.publish('user-analytics',analyticsData)
            handleStatusGaCalls({eventName : 'plan_selection',subSection : null, type : 'plan', reason : plan?.title, status : null, additionalLabel : null, action : 'Plan Selection', paymentStatus : null,eventCategory : 'Subscription',section : 'checkout'})
        }
        pushStepToFlow("plan-selection")
        let selectedPlanId = planId
        handleUpdatedPlan({ planDetails, plan, plans, contentDetails })
        publishIsActive({ selectedPlanId, planDetails, selectedType: type })
        let payload = {
          ...plan,
        }
        delete payload['subscriptionPopupFonts'];
        //PLAN_SELECTION
        let userData = fetchUserObject()
        let add_to_cart_Payload = {
          section : 'checkout',
          event_label1 : plan?.planId,
          // event_label2 : plan?.title, // Removing due to Duplicate
          event_label2 : plan?.type,
          event_label3 : 1,
          etstamp : Date. now(),
          logged_in_status : userData?.userId ? 'Yes'  : 'No',
          subscribed_status : userData?.isSubscribed,
          // device_id : getDeviceId() || "", //This violates GDPR/Google terms
          uid: userData?.userId || null,
          profid : userData?.profiles?.length ? userData?.profiles[0]?.profileId : '',
          // email : userData?.email, //This violates GDPR/Google terms
          // mobile : userData?.mobile, // Yes, collecting and sending mobile numbers to Google Analytics 4 (GA4) violates both GDPR and Google's Terms of Service,
          // last_transaction_amount : null,
          subscription_plan : plan?.title,
          // user_location : null, //This violates GDPR/Google terms
          event_value : plan?.amount,
          payment_status : null
        }
        

        let userProperties = await getUserProperties()
        let addToCartNewPayload = {
          ecommerce: {
            currency: currency,
            value: plan?.amount, 
            items: [ {...add_to_cart_Payload, ...userProperties},
            ],
          }
        }
        trackEvent('begin_checkout',addToCartNewPayload,null)
        trackEvent('add_to_cart', addToCartNewPayload,null)
        trackEvent('view_item', addToCartNewPayload,null)
        trackEvent('view_cart', addToCartNewPayload,null)
          
        let add_to_cart_payload_userBeacon = {
          currency: currency, items: [
            {
              item_id: selectedPlanId,
              item_name: plan?.title,
              price: plan?.amount,
              quantity: 1
            }
          ],
        }
        pubsub.publish('user-analytics',{ename:"add_to_cart",data:add_to_cart_payload_userBeacon})

      }}
    >
      {ctaStyleType != "default" ? <div tabIndex={0} className="cta-text-wrapper">
        <div className="title-container"><p className="title" style={{ fontSize: fontpopupCtaTitleSize, fontFamily: fontpopupCtaTitleStyle }}>
          {showPlanFromPlanInfo && plansDetail?.title ? plansDetail?.title : title}
          </p>
          <p className="sub-title" style={{ fontSize: fontpopupCtaSubTitleSize, fontFamily: fontpopupCtaSubTitleStyle }}>
            {showPlanFromPlanInfo && plansDetail?.description ? plansDetail?.description : subTitle}
          </p></div>
        {discountedPrice || (displayStrikeThroughPrice && strikeThroughPrice) ? 
        <p style={{ fontSize: fontpopupPriceFontSize, fontFamily: fontpopupPriceFontStyle, textWrap: "nowrap", display: 'flex', alignItems: 'center', gap: "0.3rem" }}>
          <span className='strike-price'>
            <span className='strike-through'>
              {`${getCurrencySymbol(currency)} ${amount}/${getLocalizedMonthYearText(plan?.cycleType)}`}
            </span>
            <span>
              {`${getCurrencySymbol(currency)} ${discountedPrice || strikeThroughPrice}/${getLocalizedMonthYearText(plan?.cycleType)}`}
            </span>
          </span>
        </p>
        : amount ? 
          <p style={{ fontSize: fontpopupPriceFontSize, fontFamily: fontpopupPriceFontStyle, textWrap: "nowrap" }}>
            {`${getCurrencySymbol(currency)} ${discountedPrice ? discountedPrice : amount}${plan?.cycleType ? `/${getLocalizedMonthYearText(plan?.cycleType)}` : ''}`}
          </p> 
        : ''
        }
      </div> : <div className='more-option-cta' onClick={() => handleMorePurchaseOptions()}>{title || 'More purchase options'}</div>}
    </div>
  )
}

export default CtaHOC(MonetisationCta)